// @ts-nocheck
import * as actionTypes from './permanentBorderActionTypes';

const setComponent = (compRef) => ({
  type: actionTypes.SET_COMPONENT,
  compRef,
});

export { setComponent };
